import React from 'react'
import { Heading3, UploadElement } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { AiEmptyUploadImageSection } from './AiEmptyUploadImageSection'

export type AiUploadedImage = {
  id: string
  name: string
  file: File
  previewUrl: string
}

export const getImageIdsInOrder = (items: Array<{ id: string }>) => items.map((item) => item.id)
export const createImageReorderHandler =
  (onReorder: (imageIdsInOrder: string[]) => void) => (items: Array<{ id: string }>) =>
    onReorder(getImageIdsInOrder(items))

interface AiUploadImageSectionProps {
  errorText?: string
  images: AiUploadedImage[]
  onFileSelect: (files: FileList | null) => void
  onRemove: (imageId: string) => void
  onReorder: (imageIdsInOrder: string[]) => void
}

export const AiUploadImageSection = ({
  errorText,
  images,
  onFileSelect,
  onRemove,
  onReorder,
}: AiUploadImageSectionProps) => {
  const { t } = useTranslation()

  if (images.length === 0) {
    return <AiEmptyUploadImageSection errorText={errorText} onFileSelect={onFileSelect} />
  }

  return (
    <section className='margin-bottom-l'>
      <Heading3 className='font-body-medium-bold margin-bottom-s'>
        {t('wizard.uploadAiBanner.modal.photos.sectionTitle')}
      </Heading3>
      <UploadElement.Root
        accept='image/jpeg,image/png'
        onFileSelect={onFileSelect}
        status={errorText ? 'error' : 'uploaded'}
      >
        <UploadElement.ImageList
          items={images.map((image) => ({
            alt: image.name,
            id: image.id,
            src: image.previewUrl,
          }))}
          onRemove={onRemove}
          onReorder={createImageReorderHandler(onReorder)}
          thumbnailSize={80}
          title={t('wizard.uploadAiBanner.modal.photos.tileTitle')}
          data-testid='ai-upload-photos-list'
        >
          <UploadElement.AddButton size={80} />
        </UploadElement.ImageList>
        <UploadElement.Error>{errorText}</UploadElement.Error>
      </UploadElement.Root>
    </section>
  )
}
